import React, { Component }  from 'react';

const SocialActivityImage = (props) => {
	return(<div className="activity-image">
		<a className="focusable" href={props.href}>
			<img src={props.entity.metadatas.image_small || 'https://www.clarovideo.com/webclient/sk_core/images/place_hl.png' } />
		</a>	
	</div>)
}

export default SocialActivityImage;


// WEBPACK FOOTER //
// ./src/components/Social/SocialActivityImage.jsx